@if(loading) {

} @else {
  <form *ngIf="newIndexForm" [formGroup]="newIndexForm">
    <div class="grid">
      <div class="col-12 md:col-6">
        <div class="card p-fluid">

          <div class="d-flex mt-2 row">
            <div class="field col-6">
              <app-form-field formFieldId="name" label="Name" [form]="newIndexForm" controlName="name">
                <input pInputText id="name" type="text" formControlName="name" required/>
              </app-form-field>
            </div>
            <div class="field col-6">
              <app-form-field formFieldId="indexName" label="Index Name" [form]="newIndexForm" controlName="indexName">
                <input pInputText id="indexName" type="text" formControlName="indexName" required/>
              </app-form-field>
            </div>
          </div>

          <div class="d-flex mt-2 row">
            <div class="field col-6">
              <app-form-field formFieldId="roles" label="Roles" [form]="newIndexForm" controlName="roles">
                <p-multiSelect id="roles" [options]="roleOptions" formControlName="roles" placeholder="Select roles"
                               appendTo="body"></p-multiSelect>
              </app-form-field>
            </div>
            <div class="field col-6">
              <app-form-field formFieldId="deploymentId" label="Model" [form]="newIndexForm" controlName="deploymentId">
                <p-dropdown id="deploymentId" [options]="getCompletionModels()" formControlName="deploymentId"
                            optionLabel="modelFriendlyName" optionValue="id"
                            placeholder="Select model" appendTo="body"></p-dropdown>
              </app-form-field>
            </div>
          </div>

          <app-form-field formFieldId="prompt" label="Prompt" [form]="newIndexForm" controlName="prompt"
                          containerClass="field grid mt-2"
                          labelContainerClass="col-12 mb-2 md:col-2 md:mb-0 d-flex align-items-center gap-2"
                          contentClass="col-12 md:col-10 mt-1">
            <textarea pInputTextarea id="prompt" rows="8" cols="30" formControlName="prompt" required></textarea>
          </app-form-field>

          <div class="d-flex mt-2 row">
            <div class="field col-6">
              <app-form-field formFieldId="lastMessages" label="Last Messages" [form]="newIndexForm" controlName="lastMessages"
                              additionalMessage="Value between 0 and 100">
                <input pInputText id="lastMessages" type="number" formControlName="lastMessages" required [min]="0"
                       [max]="100" placeholder="Value between 0 and 100"/>
              </app-form-field>
            </div>
            <div class="field col-6">
              <app-form-field formFieldId="documentCount" label="Document Count" [form]="newIndexForm" controlName="documentCount"
                              additionalMessage="Value between 0 and 100">
                <input pInputText id="documentCount" type="number" formControlName="documentCount" required [min]="0"
                       [max]="100" placeholder="Value between 0 and 100"/>
              </app-form-field>
            </div>
          </div>

          <div class="mt-3">
            <h3 class="mb-0">Rewrite Settings</h3>
          </div>

          <app-form-field formFieldId="rewritePrompt" label="Rewrite Prompt" [form]="newIndexForm" controlName="rewritePrompt"
                          tooltip="Supported placeholders:\n{query} - original user question\n{n} - number of rewrite results"
                          tooltipStyleClass="wide-tooltip"
                          containerClass="field grid mt-2"
                          labelContainerClass="col-12 mb-2 md:col-2 md:mb-0 d-flex align-items-center gap-2"
                          contentClass="col-12 md:col-10 mt-1">
            <textarea pInputTextarea id="rewritePrompt" rows="5" cols="30" formControlName="rewritePrompt"
                      required></textarea>
          </app-form-field>

          <div class="d-flex mt-2 row">
            <div class="field col-6">
              <app-form-field formFieldId="rewriteCount" label="Rewrite Count" [form]="newIndexForm" controlName="rewriteCount"
                              additionalMessage="Minimum value 1.">
                <input pInputText id="rewriteCount" type="number" formControlName="rewriteCount" required [min]="1"
                       placeholder="Minimum value 1"/>
              </app-form-field>
            </div>
          </div>

          <div class="d-flex mt-2 row">
            <div class="field col-6">
              <app-form-field formFieldId="rewriteDeploymentId" label="Rewrite Model" [form]="newIndexForm"
                              controlName="rewriteDeploymentId">
                <p-dropdown id="rewriteDeploymentId" [options]="getCompletionModels()" formControlName="rewriteDeploymentId"
                            optionLabel="modelFriendlyName" optionValue="id"
                            placeholder="Select model" appendTo="body"></p-dropdown>
              </app-form-field>
            </div>
            <div class="field col-6">
              <app-form-field formFieldId="maxRewriteOutputTokens" label="Max Rewrite Output Tokens" [form]="newIndexForm"
                              controlName="maxRewriteOutputTokens" additionalMessage="Value between 10 and 8192">
                <input pInputText id="maxRewriteOutputTokens" type="number" formControlName="maxRewriteOutputTokens"
                       required [min]="10" [max]="8192"
                       placeholder="Minimum value between 10 and max 8192"/>
              </app-form-field>
            </div>
          </div>

          <div class="mt-3">
            <h3 class="mb-0">AI Search Settings</h3>
          </div>

          <app-form-field formFieldId="endpoint" label="Azure Search AI Endpoint" [form]="newIndexForm" controlName="endpoint"
                          containerClass="field grid mt-2"
                          labelContainerClass="col-12 mb-2 md:col-2 md:mb-0 d-flex align-items-center gap-2"
                          contentClass="col-12 md:col-10 mt-1">
            <input pInputText id="endpoint" type="text" formControlName="endpoint" required/>
          </app-form-field>

          <div class="d-flex mt-2 row">
            <div class="field col-6">
              <app-form-field formFieldId="retrievalCount" label="Retrieval Count" [form]="newIndexForm" controlName="retrievalCount"
                              additionalMessage="Minimum value 1.">
                <input pInputText id="retrievalCount" type="number" formControlName="retrievalCount" required [min]="1"
                       placeholder="Minimum value 1"/>
              </app-form-field>
            </div>
            <div class="field col-6">
              <app-form-field formFieldId="scoringProfile" label="Scoring profile" [form]="newIndexForm" controlName="scoringProfile">
                <input pInputText id="scoringProfile" type="text" formControlName="scoringProfile"/>
              </app-form-field>
            </div>
          </div>

          <div class="d-flex mt-2 row">
            <div class="field col-6">
              <app-form-field formFieldId="embeddingDeploymentId" label="Embedding Model" [form]="newIndexForm"
                              controlName="embeddingDeploymentId">
                <p-dropdown id="embeddingDeploymentId" [options]="getEmbeddingModels()" formControlName="embeddingDeploymentId"
                            optionLabel="modelFriendlyName" optionValue="id"
                            placeholder="Select model" appendTo="body"></p-dropdown>
              </app-form-field>
            </div>
            <div class="field col-6">
              <app-form-field formFieldId="rrfConstant" label="RR Fusion Constant" [form]="newIndexForm" controlName="rrfConstant">
                <input pInputText id="rrfConstant" type="number" formControlName="rrfConstant"/>
              </app-form-field>
            </div>
          </div>

          <app-form-field formFieldId="fieldMappingVectorFieldNames" label="Field Mapping Vector Field Names"
                          [form]="newIndexForm" controlName="fieldMappingVectorFieldNames"
                          containerClass="field grid mt-2"
                          labelContainerClass="col-12 mb-2 md:col-2 md:mb-0 d-flex align-items-center gap-2"
                          contentClass="col-12 md:col-10 mt-1">
            <p-chips id="fieldMappingVectorFieldNames" formControlName="fieldMappingVectorFieldNames"/>
          </app-form-field>

          <div class="mt-3">
            <h3 class="mb-0">Synthesis Settings</h3>
          </div>

          <app-form-field formFieldId="synthesisPrompt" label="Synthesis Prompt" [form]="newIndexForm" controlName="synthesisPrompt"
                          tooltip="Supported placeholders:\n{query} - original user question\n{documents} - retrieved documents"
                          tooltipStyleClass="wide-tooltip"
                          containerClass="field grid mt-2"
                          labelContainerClass="col-12 mb-2 md:col-2 md:mb-0 d-flex align-items-center gap-2"
                          contentClass="col-12 md:col-10 mt-1">
            <textarea pInputTextarea id="synthesisPrompt" rows="5" cols="30" formControlName="synthesisPrompt"
                      required></textarea>
          </app-form-field>

          <div class="field grid mt-2 row">
            <div class="col-6">
              <app-form-field formFieldId="synthesisReasoningEffortLevel" label="Synthesis reasoning effort" [form]="newIndexForm"
                              controlName="synthesisReasoningEffortLevel">
                <p-dropdown id="synthesisReasoningEffortLevel" [options]="reasoningEffortLevelOptions"
                            formControlName="synthesisReasoningEffortLevel"
                            optionLabel="label" optionValue="value" placeholder="Select reasoning effort level"
                            appendTo="body"></p-dropdown>
              </app-form-field>
            </div>
          </div>

          <div class="mt-3">
            <h3 class="mb-0">Storage Settings</h3>
          </div>

          <div class="d-flex mt-2 row">
            <div class="field col-6">
              <app-form-field formFieldId="storageEndpoint" label="Storage Endpoint" [form]="newIndexForm" controlName="storageEndpoint">
                <input pInputText id="storageEndpoint" type="text" formControlName="storageEndpoint" required/>
              </app-form-field>
            </div>
            <div class="field col-6">
              <app-form-field formFieldId="storageContainer" label="Storage Container" [form]="newIndexForm" controlName="storageContainer">
                <input pInputText id="storageContainer" type="text" formControlName="storageContainer" required/>
              </app-form-field>
            </div>
          </div>

          <div class="field grid mt-3">
            <app-labeled-checkbox
              id="default"
              label="Set as default index"
              controlName="default"
              [form]="newIndexForm"
              tooltipText="Current default value will be overriden.">
            </app-labeled-checkbox>
          </div>


        </div>
      </div>
    </div>
  </form>

  <div class="mt-3 d-flex column-gap-3 justify-content-end">
    <button pButton pRipple type="button" class="p-button-secondary h-3rem w-full sm:w-auto" icon="pi pi-times"
            label="Cancel" (click)="onDialogCancel()"></button>
    <button pButton pRipple type="button" class="h-3rem w-full sm:w-auto" icon="pi pi-check"
            label="Confirm" (click)="onSubmit()" [loading]="processing"></button>
  </div>
}



